<template>
  <div id="kontakt">
    <h1 class="text-center mb-7">Kontakt</h1>
    <v-row align="center">
      <v-col cols="12" md="6">
        <div class="contact-info">
          <v-img
            class="contact__logo mb-2"
            src="@/assets/images/LogoBialeKancelariaDM.jpg"
          />
          <h3>
            <v-icon>streetview</v-icon> Ul. Piękna 24/26A,<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;00-549
            Warszawa
          </h3>
          <h3><v-icon>assignment</v-icon> NIP: 8381765174</h3>
          <h3><v-icon>email</v-icon> biuro@dmkancelaria.pl</h3>
          <h3><v-icon>phone</v-icon> +48 660 337 223</h3>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2444.0771909446858!2d21.015746815861622!3d52.2238153797592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471eccefbf8b34b1%3A0x35f70ac4be27ab20!2sPi%C4%99kna%2024%2F26%2C%2000-001%20Warszawa!5e0!3m2!1sen!2spl!4v1570011677328!5m2!1sen!2spl"
          width="100%"
          height="300"
          frameborder="0"
          style="border: 0;"
          allowfullscreen=""
        ></iframe>
      </v-col>
    </v-row>
    <v-card class="contact-card" color="#d6d6d6" flat>
      <h3>Formularz kontaktowy</h3>
      <v-row>
        <v-col cols="12" md="6">
          <v-form class="contact-form">
            <v-text-field
              color="accent"
              prepend-inner-icon="person"
              label="imię i nazwisko"
            >
            </v-text-field>
            <v-text-field
              color="accent"
              prepend-inner-icon="email"
              label="adres email"
            >
            </v-text-field>
            <v-text-field
              color="accent"
              prepend-inner-icon="phone"
              label="numer telefonu"
            >
            </v-text-field>
            <v-textarea color="accent" label="treść wiadomości"> </v-textarea>
          </v-form>
        </v-col>
        <v-col cols="12" md="6">
          <v-img
            class="contact-image"
            height="100%"
            width="400"
            src="@/assets/images/dm_contact.png"
          />
        </v-col>
      </v-row>
      <v-card-actions>
        <v-btn color="accent" :disabled="!privacyAgreed">
          Wyślij
        </v-btn>
        <v-checkbox
          class="checkbox__privacy"
          v-model="privacyAgreed"
          color="accent"
        >
        </v-checkbox>
        <span>
          Zapoznałem/<wbr/>Zapoznałam się z&nbsp;
          <router-link :to="{ name: 'privacyPolicy' }" class="link__privacy">
            Polityką prywatności
          </router-link>
          &nbsp;i ją akceptuję.
        </span>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  data() {
    return {
      privacyAgreed: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.contact-info {
  line-height: 1.9;
  margin: auto;
  width: 300px;
  margin-top: -40px;
}
.contact-image {
  margin: auto;
}
.contact__logo {
  max-width: 300px;
  margin-left: -8px;
}
.contact-card {
  margin: auto;
  padding: 20px;
  color: #891234;
}
.checkbox__privacy {
  margin-left: 10px;
}
.link__privacy {
  color: #891234;
  // margin-bottom: 4px;
}
</style>
